"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ServiceLocator_1 = __importDefault(require("chaire-lib-common/lib/utils/ServiceLocator"));
const MapCursorHelper_1 = require("../MapCursorHelper");
/* This file encapsulates map events specific for the 'routing' section */
// TODO: Set a flag instead of checking if the section is part of a list, especially if we add a third routing section.
const isRoutingActiveSection = (activeSection) => {
    return activeSection === 'routing' || activeSection === 'comparison';
};
const onRoutingSectionMapClick = (e) => {
    const map = e.target;
    // After releasing a dragged point, MapLibre still fires a synthetic `click`
    // (no pan happened since dragPan was disabled). Ignoring it prevents that
    // click from moving the other point to the drop location (see issue #1956).
    if (map._featureDragJustEnded) {
        map._featureDragJustEnded = false;
        e.originalEvent.stopPropagation();
        return;
    }
    ServiceLocator_1.default.eventManager.emit('routing.transit.clickedOnMap', e.lngLat.toArray());
    e.originalEvent.stopPropagation();
};
const onRoutingPointMouseDown = (e) => {
    var _a;
    const features = e.features;
    if (!features || features.length === 0) {
        return;
    }
    // start drag:
    if (e.features && e.features[0]) {
        const feature = e.features[0];
        const map = e.target;
        const location = (_a = feature.properties) === null || _a === void 0 ? void 0 : _a.location;
        if (location) {
            // TODO Do not hardcode those strings
            map._currentDraggingFeature = location === 'origin' ? 'routingOrigin' : 'routingDestination';
            ServiceLocator_1.default.eventManager.emit('map.disableDragPan');
            (0, MapCursorHelper_1.addDraggingClass)();
        }
    }
};
const onRoutingPointMouseUp = (e) => {
    const map = e.target;
    if (map._currentDraggingFeature === 'routingOrigin' || map._currentDraggingFeature === 'routingDestination') {
        ServiceLocator_1.default.eventManager.emit(map._currentDraggingFeature === 'routingOrigin'
            ? 'routing.transit.updateOrigin'
            : 'routing.transit.updateDestination', e.lngLat.toArray());
        map._currentDraggingFeature = null;
        // Ignore the synthetic click MapLibre fires right after this drag-release.
        // Also clear the flag after a short delay in case that synthetic click
        // never fires, so it can't end up blocking a later, legitimate click.
        map._featureDragJustEnded = true;
        setTimeout(() => {
            map._featureDragJustEnded = false;
        }, 300);
        (0, MapCursorHelper_1.removeDraggingClass)();
        (0, MapCursorHelper_1.removeHoverClass)(); // Clean up hover state since mouseleave doesn't fire during drag
        ServiceLocator_1.default.eventManager.emit('map.enableDragPan');
    }
};
const onRoutingPointMouseMove = (e) => {
    const map = e.target;
    if (map._currentDraggingFeature === 'routingOrigin') {
        ServiceLocator_1.default.eventManager.emit('routing.transit.dragOrigin', e.lngLat.toArray());
        e.originalEvent.stopPropagation();
    }
    else if (map._currentDraggingFeature === 'routingDestination') {
        ServiceLocator_1.default.eventManager.emit('routing.transit.dragDestination', e.lngLat.toArray());
        e.originalEvent.stopPropagation();
    }
};
const onRoutingSectionContextMenu = (e) => {
    ServiceLocator_1.default.eventManager.emit('map.showContextMenu', e, [
        {
            title: 'transit:transitRouting:contextMenu:SetAsOrigin',
            onClick: () => ServiceLocator_1.default.eventManager.emit('routing.transit.clickedOnMap', e.lngLat.toArray(), true)
        },
        {
            title: 'transit:transitRouting:contextMenu:SetAsDestination',
            onClick: () => ServiceLocator_1.default.eventManager.emit('routing.transit.clickedOnMap', e.lngLat.toArray(), false)
        }
    ]);
};
const routingSectionEventDescriptors = [
    { type: 'map', eventName: 'click', condition: isRoutingActiveSection, handler: onRoutingSectionMapClick },
    { type: 'map', eventName: 'contextmenu', condition: isRoutingActiveSection, handler: onRoutingSectionContextMenu },
    {
        type: 'layer',
        eventName: 'mousedown',
        layerName: 'routingPoints',
        condition: isRoutingActiveSection,
        handler: onRoutingPointMouseDown
    },
    { type: 'map', eventName: 'mouseup', condition: isRoutingActiveSection, handler: onRoutingPointMouseUp },
    { type: 'map', eventName: 'mousemove', condition: isRoutingActiveSection, handler: onRoutingPointMouseMove }
];
exports.default = routingSectionEventDescriptors;
//# sourceMappingURL=RoutingSectionMapEvents.js.map